// FLAGS: none
// Error-boundary fallback that stamps the App Insights session and operation ids into the page.
import ErrorPage from "@src/components/ErrorPage";
import { appInsights } from "@src/utils/appInsights";

export const ErrorPageWithAppInsights = () => (
  <ErrorPage
    message={`Session Id: ${appInsights.context.getSessionId()}, Operation Id: ${appInsights.context.telemetryTrace.traceID}`}
  />
);
